/**
 * Comprime un'immagine File se supera maxSizeMB.
 * Ridimensiona a max 2048px e riduce qualita JPEG progressivamente.
 */
export default async function comprimeImmagine(file, maxSizeMB = 4) {
  return new Promise((resolve) => {
    const maxBytes = maxSizeMB * 1024 * 1024;

    if (file.size <= maxBytes) {
      resolve(file);
      return;
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      let { width, height } = img;
      const maxDim = 2048;

      if (width > maxDim || height > maxDim) {
        if (width > height) {
          height = Math.round(height * maxDim / width);
          width = maxDim;
        } else {
          width = Math.round(width * maxDim / height);
          height = maxDim;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      let quality = 0.85;
      const tryCompress = () => {
        canvas.toBlob((blob) => {
          if (blob.size <= maxBytes || quality <= 0.3) {
            const compressedFile = new File([blob], file.name.replace(/\.\w+$/, '.jpg'), {
              type: 'image/jpeg',
              lastModified: Date.now()
            });
            resolve(compressedFile);
          } else {
            quality -= 0.1;
            tryCompress();
          }
        }, 'image/jpeg', quality);
      };
      tryCompress();
    };

    img.onerror = () => resolve(file);
    img.src = URL.createObjectURL(file);
  });
}
